// MUST be first: sets the per-tab impersonation flag + seeds sessionStorage
// before the auth store (transitively imported below) initializes its persist.
import './lib/impersonation-bootstrap';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { App } from './App';
import { queryClient } from '@/lib/query-client';
import { startGeolocationCapture } from '@/lib/geolocation';
import { z } from 'zod';
import { SetErrorFunction } from '@sinclair/typebox/errors';
import './lib/i18n';
import { zodErrorMap } from '@/lib/zod-error-map';
import { typeboxErrorFunction } from '@/lib/typebox-error-function';
import './index.css';

// Best-effort GPS prompt at boot. Resolution + permission dialog happen async;
// requests sent before the user grants permission simply ship without GPS.
void startGeolocationCapture();

// Every form's validation messages in the operator's language, not zod's or
// TypeBox's English.
z.setErrorMap(zodErrorMap);
SetErrorFunction(typeboxErrorFunction);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />}
    </QueryClientProvider>
  </React.StrictMode>,
);
